import { createApp } from 'vue'
import mitt from 'mitt'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import App from './App.vue'
import store from './store'
import router from './router'

export const eventBus = mitt()

const app = createApp(App)
app.use(store)
app.use(router)
app.mount('#app')
